module.exports = "https://coinrabbit.io/_next/static/images/Rabbit+windows-7ede83708e73b74a69b54ff343b3909c.png";